<template>
  <div class="page-content user-call-sms-email-mail">
    <user-call-sms-email-mail-options />
    <exclude-ab-test />
    <email-checker />
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

const UserCallSmsEmailMailOptions = defineAsyncComponent(() => import('./CallSmsEmailMailOptions/UserCallSmsEmailMailOptions.vue') as any);

const EmailChecker = defineAsyncComponent(() => import('./CallSmsEmailMailOptions/EmailChecker.vue') as any);

const ExcludeAbTest = defineAsyncComponent(() => import('./CallSmsEmailMailOptions/ExcludeAbTest.vue') as any);

onMounted(async () => {
  const route = useRoute();
  const hash = route.hash;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>
